export const Links = {
    home: "/",
    services: "/services",
    revolution: "/revolution",
    about: "/about",
    contact: "/contact",
    estimate: "/estimate",
    customsofware: "/customsofware",
    mobiledevelopment: "/mobiledevelopment",
    websitedevelopment: "/websitedevelopment"
}